import { FavouriteIcon, NavigationIcon } from '@tymbe/ui-icons';
import { DropDownMenuOption } from '../ShiftDetail/DropDownMenu';
import Options from '../Options';

interface ShiftDetailHeaderProps {
  showHistory: boolean;
  toggleShowHistory: () => void;
  onClose: () => void;
  menuOptions: DropDownMenuOption[];
}

export const ShiftDetailHeader = ({
  showHistory,
  toggleShowHistory,
  onClose,
  menuOptions,
}: ShiftDetailHeaderProps) => {
  return (
    <div className="flex align-middle text-heading-4-xl text-secondary-600">
      {showHistory ? (
        <div className="flex justify-start items-center">
          <NavigationIcon
            name="west"
            onClick={toggleShowHistory}
            className="mr-2 size-5 cursor-pointer"
          />
          Historie
          <FavouriteIcon
            name="close"
            className="size-5 text-secondary-400 absolute right-2 top-2 cursor-pointer"
            onClick={onClose}
          />
        </div>
      ) : (
        <>
          Detail směny
          <Options menuOptions={menuOptions} className="text-secondary-500 ml-2" />
          <FavouriteIcon
            name="close"
            className="size-5 text-secondary-400 absolute right-2 top-2 cursor-pointer"
            onClick={onClose}
          />
        </>
      )}
    </div>
  );
};
